import { Suspense } from "react";
import { useAppGlobStore } from "../../../appGlobalStore";
import { XmSpinner } from "../../../component/spinner/XmSpinner";
import { MenuNode } from "../../../model/MenuNode";
import { BasePage } from "../../basePage/BasePage";

const isLeafSet: Set<string> = new Set([
  "storage",
  "san",
  "lan",
  "tape"
]);

export function topMenuToMenuItemsRight(menu: MenuNode[], doChildren = true): MenuNode[] {
  return menu.map(item => {
    const isInLeafSet = isLeafSet.has(item.key as string);
    return {
      key: item.key,
      title: item.title === "Linux" ? "OS Agent" : item.title,
      path: item.path + "_cmdb",
      isLeaf: doChildren && !isInLeafSet ? false : true,
      children: doChildren && !isInLeafSet && item.children ? topMenuToMenuItemsRight(item.children, false) : undefined,
      component: (
        <Suspense fallback={<XmSpinner />}>
          <CMDB className={isInLeafSet ? item.key as string : undefined} hw_type={!isInLeafSet ? (item.key as string).split('/').at(-1) : undefined} />
        </Suspense>
      )
    };
  });
}

function transformMenuTree(menu: MenuNode[], pathSuffix: string): MenuNode[] {
  return menu.map(item => {
    return {
      key: item.key,
      title: item.title,
      // slashes/whitespace (e.g. "Windows / Hyper-V") would split the path into extra route segments
      path: "/" + (item.title as string || '').toLowerCase().replace(/[\s/]+/g, '-') + pathSuffix,
      isLeaf: item.children ? false : true,
      children: item.children?.length ? transformMenuTree(item.children, pathSuffix) : undefined,
      component: item.children ? undefined : (
        <Suspense fallback={<XmSpinner />}>
          <BasePage url={item.key as string}></BasePage>
        </Suspense>
      )
    };
  });
}

export function transformTopologyMenu(menu: MenuNode[]): MenuNode[] {
  return transformMenuTree(menu, "_topology");
}

export function transformTrendsMenu(menu: MenuNode[]): MenuNode[] {
  return transformMenuTree(menu, "_trends");
}

export const cmdbChildren = topMenuToMenuItemsRight(useAppGlobStore.getState().topMenu.filter(item => item.key === '/dashboard' || item.key === '/custom'));
export const topologyChildren = transformTopologyMenu(useAppGlobStore.getState().topologyMenu);
export const trendsChildren = transformTrendsMenu(useAppGlobStore.getState().trendsMenu);

interface CMDBProps {
  className?: string;
  hw_type?: string;
}

const CMDB = ({ className, hw_type }: CMDBProps) => {

  return (
    <BasePage
      url={`/api/menu/v1/cmdb?${className ? "class=" + className : "hw_type=" + hw_type}`}
    />
  );
};

export default CMDB;